import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { map, take } from 'rxjs/operators';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.token$.pipe(
    take(1),
    map((token) => {
      if (token) {
        return true;
      }
      authService.clearAuthFeedback();
      void router.navigate(['/']);
      return false;
    })
  );
};
